import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  text: 'Innova Pools transformó nuestra piscina por completo. El equipo fue profesional y el resultado superó nuestras expectativas.',
  author: 'María G.',
  location: 'Orlando, FL'
}, {
  text: 'Excelente servicio. Llegaron a tiempo, fueron muy limpios y nuestra piscina quedó como nueva.',
  author: 'James R.',
  location: 'Kissimmee, FL'
}, {
  text: 'Los recomiendo al 100%. Nos dieron mantenimiento gratis por 3 meses y el agua se mantiene cristalina.',
  author: 'Carlos M.',
  location: 'Davenport, FL'
}, {
  text: 'Very professional team. They diagnosed the issue quickly and fixed everything within days.',
  author: 'Sarah T.',
  location: 'Winter Garden, FL'
}];
export function Testimonials() {
  return <section id="testimonios" className="py-20 bg-pool-50" data-id="element-252">
      <div className="container mx-auto px-4 md:px-6" data-id="element-253">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-254">
          <h2 className="text-pool-600 font-semibold tracking-wider uppercase text-sm mb-2" data-id="element-255">
            Testimonios
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-256">
            Lo Que Dicen Nuestros Clientes
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-257">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-258">
              <Quote className="absolute top-6 right-6 text-gray-100" size={60} data-id="element-259" />
              <div className="flex gap-1 mb-6 relative z-10" data-id="element-260">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-gold-400 text-gold-400" data-id="element-261" />)}
              </div>
              <p className="text-gray-700 text-lg mb-6 italic relative z-10" data-id="element-262">
                "{testimonial.text}"
              </p>
              <div className="relative z-10" data-id="element-263">
                <p className="font-bold text-navy-900" data-id="element-264">{testimonial.author}</p>
                <p className="text-sm text-gray-500" data-id="element-265">{testimonial.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}